import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useUserStore } from '@/stores/user'
import { ChangesRequestsApi } from '@/components/routes/changes-requests/helpers/requests'

export const useRequestsStore = defineStore('requests', () => {
  const userStore = useUserStore()

  const availableRequests = ref(0)

  async function fetchRequests() {
    if (
      userStore.isSED ||
      userStore.haveDepsHead ||
      userStore.haveFacultiesHead ||
      userStore.isAdmin
    ) {
      try {
        availableRequests.value = (
          await ChangesRequestsApi.getAvailableRequests()
        ).data
      } catch (e) {
        availableRequests.value = 0
      }
    }
  }

  function addRequests(n: number) {
    availableRequests.value += n
  }

  return {
    availableRequests,
    addRequests,
    fetchRequests
  }
})
